export const DEFAULT_CLOSED_DRAWER_CLEARANCE = 112;
export const CLOSED_DRAWER_CLEARANCE_GAP = 24;

const toPositivePixelNumber = (value, fallback = 0) => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback;
  }

  return Math.ceil(parsed);
};

export const getClosedDrawerClearance = (
  drawerHeight,
  {
    fallback = DEFAULT_CLOSED_DRAWER_CLEARANCE,
    gap = CLOSED_DRAWER_CLEARANCE_GAP,
  } = {}
) => {
  const measuredHeight = Number(drawerHeight);

  if (!Number.isFinite(measuredHeight) || measuredHeight <= 0) {
    return fallback;
  }

  return Math.max(fallback, Math.ceil(measuredHeight + gap));
};

export const getViewportAwareClosedDrawerClearanceValue = (
  baseClearance,
  viewportBottomOffset = 0,
  { fallback = DEFAULT_CLOSED_DRAWER_CLEARANCE } = {}
) => {
  const safeBaseClearance = toPositivePixelNumber(baseClearance, fallback);
  const safeViewportBottomOffset = toPositivePixelNumber(viewportBottomOffset);

  return `calc(${safeBaseClearance}px + max(${safeViewportBottomOffset}px, calc(100vh - 100dvh)))`;
};
